<template>
  <div class="featured-faqs-list">
    <div
      v-for="item in items"
      :key="getItemId(item)"
      :class="{
        'is-opened': currentId === getItemId(item),
      }"
      class="featured-faqs-list__item"
    >
      <h4>
        <button class="featured-faqs-list__toggler" @click.prevent="() => toggle(item)">
          <span class="featured-faqs-list__toggler-icon">
            <pt-icon-faq-toggle />
          </span>
          <span class="featured-faqs-list__toggler-text title is-4">
            {{ getItemTitle(item) }}
          </span>
        </button>
      </h4>
      <transition name="featured-faqs-list__content" @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave" @leave="leave">
        <div v-if="getItemId(item) === currentId" class="featured-faqs-list__content">
          <div v-if="hasItemDescription(item)">
            <bard :as-content="true" :content="item.description" />
          </div>
          <div v-else>
            {{ item.answer }}
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import PtIconFaqToggle from '~/components/global/icons/PtIconFaqToggle.vue';
import type { LooseObject } from '~/types/generic';
import Bard from '~/components/content/Bard.vue';

const props = defineProps({
  items: {
    type: Array as () => Array<LooseObject>,
    required: true,
  },
  onClick: {
    type: Function,
    default: () => {},
  },
});

const currentId = ref<string | null>(null);

const toggle = (item: LooseObject) => {
  props.onClick('click', item, 'Hit Clicked!');
  const itemId = getItemId(item);

  currentId.value = currentId.value === itemId ? null : itemId;
};

const getItemId = (item: LooseObject) => item?.objectID || item?.id || item?.question || item?.title;
const getItemTitle = (item: LooseObject) => item?.title || item?.question || '';
const hasItemDescription = (item: LooseObject) => {
  if (!item?.description || typeof item.description !== 'object') {
    return false;
  }

  if (Array.isArray(item.description)) {
    return item.description.length > 0;
  }

  return Object.keys(item.description).length > 0;
};

const beforeEnter = (el: HTMLElement) => {
  el.style.height = '0';
  el.style.opacity = '0';
};

const enter = (el: HTMLElement) => {
  el.style.height = el.scrollHeight + 'px';
  el.style.opacity = '1';
};

const beforeLeave = (el: HTMLElement) => {
  el.style.height = el.scrollHeight + 'px';
  el.style.opacity = '1';
};

const leave = (el: HTMLElement) => {
  el.style.height = '0';
  el.style.opacity = '0';
};
</script>
